// src/components/common/FormDatePicker.jsx

import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const FormDatePicker = ({
  label,
  name,
  setValue,
  watch,
  errors,
  placeholder = "dd-mm-yyyy",
  maxDate = new Date(),
  minDate,
}) => {
  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="position-relative w-100">
      <input
        type="text"
        className="form-control pe-5"
        // className={`form-control pe-5 ${errors?.[name] ? "is-invalid" : ""}`} 
        onClick={onClick}
        ref={ref}
        value={value || ""}
        readOnly
        placeholder={placeholder}
        style={{ backgroundColor: "#fff" }}
      />
      <FaCalendarAlt
        className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted cursor-pointer"
        onClick={onClick}
        style={{ fontSize: "16px" }}
      />
    </div>
  ));

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label" htmlFor={name}>
          {label}
        </label>
      )}

      <DatePicker
        id={name}
        selected={watch(name)}
        onChange={(date) => setValue(name, date)}
        placeholderText={placeholder}
        dateFormat="dd-MM-yyyy"
        maxDate={maxDate}
        minDate={minDate}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={100}
        onChangeRaw={(e) => e.preventDefault()}
        customInput={<CustomInput />}
      />

      {errors?.[name] && (
        <div className="invalid-feedback d-block">
          {errors[name]?.message}
        </div>
      )}
    </div>
  );
};

export default FormDatePicker;
